export const GlobalDebug = (function () {
    // Guardamos el objeto original
    var savedConsole = console;

    /**
    * @param {boolean} debugOn
    * @param {boolean} suppressAll
    */
     return function (debugOn, suppressAll) {
        var suppress = suppressAll || false;
        
        if (debugOn === false) {
            // NO hagas 'console = {}', eso rompe referencias externas.
            // Mejor sobrescribe los métodos del objeto existente.
            
            console.log = function () { };
            
            if (suppress) {
                console.info = function () { };
                console.warn = function () { };
                console.error = function () { };
                console.debug = function () { }; // <--- AGREGADO: Definir debug vacío
            } else {
                console.info = savedConsole.info;
                console.warn = savedConsole.warn;
                console.error = savedConsole.error;
                // <--- AGREGADO: Restaurar debug original o usar log si no existe
                console.debug = savedConsole.debug || savedConsole.log; 
            }
        } else {
            // Restaurar todo al estado original
            console = savedConsole;
        }
    };
})();